export default __webpack_public_path__ + "static/media/vdnh.f490b33f.png";